import React from 'react'
import { observer } from 'mobx-react'
import SVGIcon from '../helpers/icons'

function Info ({position = 'bottom-left', text}) {
  return (
    <div className={position ? 'info-box info-box--' + position : 'info-box'}>
      <SVGIcon type={'info'} fill={'#D14142'} className={'info-box__icon'}/>
      <span className={'info-box__text'}>{text}</span>
    </div>
  )
}

export default observer(Info)